<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>统计</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <div>
            <div class="filter">
              <el-form
                :inline="true"
                :model="filter"
                ref="filterForm"
                label-position="right"
                label-width="80px"
                class="search-form"
                size="small"
              >
                <el-form-item label="关键字" prop="query">
                  <el-input
                    v-model="filter.query"
                    clearable
                    placeholder="序列号，型号，零件号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="产品状态" prop="drill_status">
                  <el-select v-model="filter.drill_status">
                    <el-option :key="1" label="成品" :value="1"></el-option>
                    <el-option :key="2" label="半成品" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="数据周期" prop="month" label-width="120px">
                  <el-date-picker
                    clearable
                    v-model="filter.month"
                    type="month"
                    size="small"
                    value-format="yyyy-MM"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
              <div style="margin-left: 80px">
                <el-button
                  type="primary"
                  size="small"
                  @click="
                    page = 1
                    getData()
                  "
                  >筛选</el-button
                >
                <el-button size="small" @click="getData(true)">重置</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="panel">
          <div>
            <div class="pad-btm form-inline">
              <div class="row">
                <div class="col-md-12 text-right">
                  <file-button
                    obj="drill_manhour"
                    :importButton="false"
                    :filter="filter"
                    style="float: right"
                  ></file-button>
                </div>
              </div>
            </div>
            <el-table
              v-loading="loading"
              border
              size="small"
              :data="drills"
              style="width: 100%"
            >
              <el-table-column prop="serial_number" label="序列号">
                <template slot-scope="scope">
                  <DrillLink :no="scope.row.serial_number"></DrillLink>
                  <template v-if="!scope.row.produce_end_date">
                    <el-tag
                      class="ml-5"
                      type="danger"
                      size="mini"
                      effect="plain"
                      >半成品</el-tag
                    >
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                label="型号"
                prop="model_number"
                align="center"
              ></el-table-column>
              <el-table-column
                label="零件号"
                prop="component_number"
                align="center"
              ></el-table-column>
              <el-table-column label="开始生产日期" align="center">
                <template slot-scope="scope">
                  {{ scope.row.produce_start_date || '-' }}
                </template>
              </el-table-column>
              <el-table-column label="完成生产日期" align="center">
                <template slot-scope="scope">
                  {{ scope.row.produce_end_date || '-' }}
                </template>
              </el-table-column>
              <el-table-column
                label="总工时（截止上月）"
                prop="total_man_hour"
                align="center"
              >
              </el-table-column>
            </el-table>
            <el-pagination
              background
              class="m-t-20 text-right"
              :page-size="filter.size"
              :current-page.sync="filter.page"
              @current-change="getData(false)"
              layout="total, prev, pager, next"
              :total="count"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { drillCostStatistic } from '@/service/getData'
export default {
  data() {
    return {
      filter: {
        page: 1,
        size: 10,
        month: Vue.time(
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
        ).format('YYYY-MM'),
        query: '',
        drill_status: '',
      },
      count: 0,
      drills: [],
      loading: false,
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.month = Vue.time(
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
        ).format('YYYY-MM')
        this.filter.query = ''
        this.filter.drill_status = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1

      this.loading = true
      let res = await drillCostStatistic(params)
      if (res.status == 0) {
        this.loading = false
        this.drills = res.data.list
        this.count = res.data.count
      }
    },
  },
}
</script>